(function () {
  var root = document.querySelector('[data-kwikpass-login]');
  if (!root) return;

  var config = window.MandiraKwikPass || {};
  var helpers = window.MandiraKwikPassHelpers;
  var phoneStep = root.querySelector('[data-kp-step="phone"]');
  var otpStep = root.querySelector('[data-kp-step="otp"]');
  var phoneInput = root.querySelector('#kp-phone');
  var otpHidden = root.querySelector('#kp-otp');
  var otpDigits = Array.from(root.querySelectorAll('[data-kp-otp-digit]'));
  var phoneForm = root.querySelector('[data-kp-phone-form]');
  var otpForm = root.querySelector('[data-kp-otp-form]');
  var errorEl = root.querySelector('[data-kp-error]');
  var messageEl = root.querySelector('[data-kp-message]');
  var resendBtn = root.querySelector('[data-kp-resend]');
  var changeBtn = root.querySelector('[data-kp-change]');
  var googleBtn = root.querySelector('[data-kp-google]');
  var submitPhone = root.querySelector('[data-kp-submit-phone]');
  var submitOtp = root.querySelector('[data-kp-submit-otp]');
  var returnTo = root.getAttribute('data-return-to') || '/pages/kp-account';
  var phone = '';

  function normalizeIndianMobile(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 10) return digits;
    if (digits.length === 12 && digits.indexOf('91') === 0) return digits.slice(-10);
    return '';
  }

  function isValidIndianMobile(value) {
    return normalizeIndianMobile(value).length === 10;
  }

  function toE164India(value) {
    var local = normalizeIndianMobile(value);
    return local ? '+91' + local : '';
  }

  function getOtpCode() {
    if (otpDigits.length) {
      return otpDigits.map(function (el) { return el.value || ''; }).join('');
    }
    return otpHidden ? otpHidden.value.trim() : '';
  }

  function syncOtpHidden() {
    var code = getOtpCode();
    if (otpHidden) otpHidden.value = code;
    if (submitOtp) submitOtp.disabled = code.length !== 4;
  }

  function setBusy(busy) {
    if (submitPhone) {
      submitPhone.disabled = busy || !isValidIndianMobile(phoneInput && phoneInput.value);
      submitPhone.textContent = busy ? 'Sending OTP...' : 'Continue';
    }
    if (submitOtp) {
      submitOtp.disabled = busy || getOtpCode().length !== 4;
      submitOtp.textContent = busy ? 'Verifying...' : 'Verify OTP';
    }
    if (resendBtn) resendBtn.disabled = busy;
    if (changeBtn) changeBtn.disabled = busy;
  }

  function showError(text) {
    if (!errorEl) return;
    errorEl.textContent = text || '';
    errorEl.hidden = !text;
  }

  function showMessage(text) {
    if (!messageEl) return;
    messageEl.textContent = text || '';
    messageEl.hidden = !text;
  }

  function showStep(step) {
    if (phoneStep) phoneStep.hidden = step !== 'phone';
    if (otpStep) otpStep.hidden = step !== 'otp';
    if (step === 'otp' && otpDigits[0]) otpDigits[0].focus();
  }

  function getSdk() {
    return (helpers && helpers.getSdk && helpers.getSdk()) || window.__KP_LOGIN_SDK_INSTANCE__;
  }

  function extractShopifyRedirect(result) {
    if (!result) return '';
    var candidates = [
      result.redirectUrl,
      result.shopifyLoginUrl,
      result.multipassUrl,
      result.multipass_url,
      result.url,
      result.data && result.data.redirectUrl,
      result.data && result.data.shopifyLoginUrl,
      result.data && result.data.multipassUrl,
      result.data && result.data.multipass_url,
      result.data && result.data.url,
      result.data && result.data.loginUrl,
      result.response && result.response.redirectUrl,
    ];
    for (var i = 0; i < candidates.length; i++) {
      var value = candidates[i];
      if (typeof value === 'string' && value && value.indexOf('http') === 0) return value;
      if (typeof value === 'string' && value.indexOf('/account/login/multipass/') === 0) {
        return window.location.origin + value;
      }
    }
    var token =
      result.multipassToken ||
      result.multipass_token ||
      (result.data && (result.data.multipassToken || result.data.multipass_token || result.data.token));
    if (typeof token === 'string' && token.length > 20) {
      return window.location.origin + '/account/login/multipass/' + token;
    }
    return '';
  }

  function finishAfterKwikPass(result) {
    var redirectUrl = extractShopifyRedirect(result);
    if (
      redirectUrl &&
      redirectUrl.indexOf('account.mandirafashion.com') === -1 &&
      redirectUrl.indexOf('customer_authentication') === -1 &&
      redirectUrl.indexOf('/authentication/login') === -1
    ) {
      window.location.assign(redirectUrl);
      return;
    }
    try {
      sessionStorage.setItem('mandira_kp_phone', toE164India(phone));
      sessionStorage.setItem('mandira_kp_verified', '1');
    } catch (e) {
      /* ignore */
    }
    window.location.assign(returnTo || '/pages/kp-account');
  }

  function openPopupFallback() {
    if (helpers && helpers.markUserLogin) helpers.markUserLogin();
    document.documentElement.classList.add('mandira-kp-user-login');
    document.body.classList.add('mandira-kp-user-login');
    if (helpers && helpers.openKpPopup && helpers.openKpPopup()) return true;
    if (typeof window.handleKpAndShopifyLogin === 'function') {
      window.handleKpAndShopifyLogin();
      return true;
    }
    return false;
  }

  async function sendOtp(event) {
    if (event) event.preventDefault();
    showError('');
    showMessage('');
    phone = phoneInput ? phoneInput.value : '';
    if (!isValidIndianMobile(phone)) {
      showError('Enter a valid 10-digit mobile number.');
      return;
    }

    var sdk = getSdk();
    if (!sdk || typeof sdk.kpSendOTP !== 'function') {
      if (openPopupFallback()) {
        showMessage('Continue in the login window.');
        return;
      }
      showError('KwikPass is still loading. Please wait a moment and try again.');
      return;
    }

    setBusy(true);
    try {
      var local = normalizeIndianMobile(phone);
      var result = await sdk.kpSendOTP(local);
      if (result && result.status === 200) {
        showStep('otp');
        showMessage(result.message || 'OTP sent successfully');
      } else {
        showError((result && result.message) || 'Could not send OTP. Try again.');
      }
    } catch (err) {
      showError((err && err.message) || 'Could not send OTP. Try again.');
    } finally {
      setBusy(false);
    }
  }

  async function verifyOtp(event) {
    if (event) event.preventDefault();
    showError('');
    showMessage('');
    var code = getOtpCode();
    if (!/^\d{4}$/.test(code)) {
      showError('Enter the 4-digit OTP.');
      return;
    }

    var sdk = getSdk();
    if (!sdk || typeof sdk.kpVerifyOTP !== 'function') {
      showError('KwikPass is still loading. Please wait a moment and try again.');
      return;
    }

    setBusy(true);
    try {
      var local = normalizeIndianMobile(phone);
      var result = await sdk.kpVerifyOTP({ phone: local, otp: Number(code) });
      if (result && result.status === 200) {
        showMessage(result.message || 'Verified — signing you in…');
        finishAfterKwikPass(result);
        return;
      }
      showError((result && result.message) || 'OTP is invalid. Please try again.');
    } catch (err) {
      showError((err && err.message) || 'OTP verification failed. Try again.');
    } finally {
      setBusy(false);
    }
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
      if (submitPhone) submitPhone.disabled = !isValidIndianMobile(phoneInput.value);
    });
  }

  otpDigits.forEach(function (box, index) {
    box.addEventListener('input', function () {
      box.value = box.value.replace(/\D/g, '').slice(0, 1);
      syncOtpHidden();
      if (box.value && otpDigits[index + 1]) otpDigits[index + 1].focus();
    });
    box.addEventListener('keydown', function (event) {
      if (event.key === 'Backspace' && !box.value && otpDigits[index - 1]) {
        otpDigits[index - 1].focus();
      }
    });
    box.addEventListener('paste', function (event) {
      var text = (event.clipboardData || window.clipboardData).getData('text') || '';
      var digits = text.replace(/\D/g, '').slice(0, 4).split('');
      if (!digits.length) return;
      event.preventDefault();
      otpDigits.forEach(function (el, i) {
        el.value = digits[i] || '';
      });
      syncOtpHidden();
      var focusIndex = Math.min(digits.length, otpDigits.length - 1);
      otpDigits[focusIndex].focus();
    });
  });

  if (phoneForm) phoneForm.addEventListener('submit', sendOtp);
  if (otpForm) otpForm.addEventListener('submit', verifyOtp);
  if (resendBtn) resendBtn.addEventListener('click', sendOtp);
  if (changeBtn) {
    changeBtn.addEventListener('click', function () {
      showStep('phone');
      otpDigits.forEach(function (el) { el.value = ''; });
      syncOtpHidden();
      showError('');
      showMessage('');
    });
  }

  if (googleBtn) {
    googleBtn.addEventListener('click', function () {
      showError('');
      showMessage('');
      var sso = root.querySelector('#kwikpass-sso-container button, #kwikpass-sso-container a, .kwikpass-sso button');
      if (sso) {
        sso.click();
        return;
      }
      if (openPopupFallback()) {
        showMessage('Continue with Google in the login window.');
        return;
      }
      showError('Google sign-in is unavailable right now.');
    });
  }

  function initSso() {
    var sdk = getSdk();
    if (sdk && typeof sdk.handleKpSSOButton === 'function') {
      sdk.handleKpSSOButton();
    }
  }

  if (helpers && helpers.onReady) {
    helpers.onReady(initSso);
  } else {
    window.addEventListener('kp-script-loaded', initSso, { once: true });
  }

  window.addEventListener('user-loggedin', function () {
    window.location.assign(returnTo || '/pages/kp-account');
  });
  window.addEventListener('user_loggedin_merchant', function () {
    window.location.assign(returnTo || '/pages/kp-account');
  });

  if (submitPhone) submitPhone.disabled = true;
  if (submitOtp) submitOtp.disabled = true;
  syncOtpHidden();
})();
